import React from 'react';
const AdvertorialHeader = () => {
  return <header className="w-full bg-[#040273] text-white" data-id="element-201">
      <div className="w-full px-3 sm:px-6 lg:px-8 py-2 sm:py-3 flex flex-col sm:flex-row sm:justify-between sm:items-center text-xs sm:text-sm border-b border-gray-200 gap-2 max-w-7xl mx-auto" data-id="element-202">
        <div className="flex items-center text-white" data-id="element-203">
          <div size={16} className="mr-1.5 text-red-400" data-id="element-204" />
          <span className="font-medium" data-id="element-205">
            127,483 views | Trending in Healthcare
          </span>
        </div>
        <div className="flex items-center justify-between sm:justify-start w-full sm:w-auto" data-id="element-206">
          <div className="text-white font-medium mr-4" data-id="element-207">
            U.S. | HEALTH & WELLNESS
          </div>
          <div className="flex items-center" data-id="element-208">
            <div className="w-4 h-4 sm:w-5 sm:h-5 mr-1.5 overflow-hidden rounded-full" data-id="element-209">
              <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Flag_of_the_United_States.svg/1920px-Flag_of_the_United_States.svg.png" alt="US Flag" className="w-full h-full object-cover" data-id="element-210" />
            </div>
            <span className="font-medium text-white" data-id="element-211">Trending in the US</span>
          </div>
        </div>
      </div>
    </header>;
};
export default AdvertorialHeader;